'use strict';

const Reflux = require('@muzzylane/reflux');
const uuid = require('uuid');
const find = require('lodash/find');

const OIDCActions = require('../actions/OIDCActions');
const SignInActions = require('../actions/sign_in_actions');
const ForgeError = require('../util/error');
const ErrorConsts = require('../constants/error');

let openIdProviders = []; 
let initialized = false;
let pendingDataActionId = null;
let action = {};

const OIDCStore = Reflux.createStore({
    listenables: [OIDCActions, SignInActions],
    init: () => { return; },

    resetState: function() {
        openIdProviders = {};
        initialized = false;
        // action = {};
    },

    emitStatus: function() {
        this.trigger(this.getState());
        action = {};
    },

    onSignOutCompleted: function(res) {
        this.resetState();
        this.emitStatus();
    },

    onSignOutFailed: function(err) {
        console.warn(err);
        this.resetState();
        this.emitStatus();
    },

    requestDataIfNeeded: function() {
        if (initialized || pendingDataActionId) {
            return;
        }
        pendingDataActionId = uuid.v4();
        OIDCActions.getOpenIdProviders(pendingDataActionId);
    },
    
    getState: function() {
        return {
            initialized: initialized,
            openIdProviders: openIdProviders,
            action: action
        };
    },

    getStateProvider: function(opId) {
        return {
            op: openIdProviders[opId], // op = abbreviation for open id provider (similar to idp for identity provider)
            action: action
        };
    },

    onError: function(actionId, err) {
        action = { id: actionId };
        if (err.status) {
            switch (err.status) {
                case 403:
                    action.error = new ForgeError({ message: "Not allowed.", stack: null });
                    break;
                default:
                    action.error = new ForgeError({ message: ErrorConsts.INTERNAL_GENERAL, stack: err.responseText || null });
            }
        }
        else {
            action.error = err;
        }

        this.emitStatus();
    },

    onGetOpenIdProvidersCompleted: function(actionId, result) {
        // console.log("onGetOpenIdProvidersCompleted: ", actionId, newData);
        action = { id: actionId };
        openIdProviders = result;
        pendingDataActionId = null;
        initialized = true;
        this.emitStatus();
    },

    onGetOpenIdProvidersFailed: function(actionId, err) {
        console.warn("onGetOpenIdProvidersFailed: ", actionId, err);
        if (actionId === pendingDataActionId) {
            pendingDataActionId = null;
        }
        this.onError(actionId, err);
    },
    
    onAddOpenIdProviderCompleted: function(actionId, newProvider) {
        // console.log("onAddOpenIdProviderCompleted: ", actionId, newData);
        action = { id: actionId };
        var test = find(openIdProviders,{id: newProvider.id});
        if (test) {
            // this probably won't happen, but if it does we must presume we already have more recent data
            console.warn("onAddOpenIdProviderCompleted but the new provider was already in the list");
        }
        else {
            openIdProviders.push(newProvider);
        }
        this.emitStatus();
    },

    onAddOpenIdProviderFailed: function(actionId, err) {
        console.warn("onAddOpenIdProviderFailed: ", actionId, err);
        this.onError(actionId, err);
    },

    
    
});

module.exports = OIDCStore;